"use client"

/**
 * The only module that references the QA panels, and only through dynamic
 * import(), so their code ships in separate chunks that load when this loader
 * is rendered. qa-panel-gate.tsx (server) renders it only for QA accounts on
 * preview/staging, or in local development. ssr: false keeps the panel out of
 * the server HTML. scripts/test-qa-panel-gate.mts enforces both.
 *
 * The dev scenario panel (and its "use server" actions) is compiled out of
 * production builds by the NODE_ENV check, as it was in the root layout.
 */
import dynamic from "next/dynamic"
import type { QaRuntimeEnv } from "./qa-env"

const QaPanel = dynamic(() => import("./qa-panel").then((module) => module.QaPanel), { ssr: false })
const DevScenarioPanel =
  process.env.NODE_ENV === "development"
    ? dynamic(() => import("./dev-scenario-panel").then((module) => module.DevScenarioPanel), {
        ssr: false,
      })
    : null

export function QaPanelLoader({ mode, env }: { mode: "qa" | "dev"; env: QaRuntimeEnv }) {
  if (mode === "dev") return DevScenarioPanel ? <DevScenarioPanel /> : null
  return <QaPanel env={env} />
}
